import CampaignList from './CampaignList'
import * as campaignActions from "../../../../../actions/campaignAction";
import { connect } from "react-redux";

const mapStateToProps = state => {
    return {
        campaignState: state.campaignReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        deleteCampaign: (campaign) => dispatch(campaignActions.deleteCampaign(campaign)),
        cloneCampaign: (campaign) => dispatch(campaignActions.cloneCampaign(campaign)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CampaignList)
